import React, { useLayoutEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { ReviewCard } from "src/components";
import { NotFound } from "./components";
import { useReviewByUserAsUser } from "src/hooks";
import { StackNavigationProp } from "@react-navigation/stack";
import { useNavigation, useRoute, RouteProp } from "@react-navigation/native";

export type ReviewByUserAsUserNavigationParam = {
  id: string;
  title: string;
  notFound: string;
};

type StackNavigationParam = {
  ReviewByUserAsUser: ReviewByUserAsUserNavigationParam;
};

export const ReviewByUserAsUserScreen: React.FC = () => {
  const navigation =
    useNavigation<
      StackNavigationProp<StackNavigationParam, "ReviewByUserAsUser">
    >();
  const route =
    useRoute<RouteProp<StackNavigationParam, "ReviewByUserAsUser">>();
  useLayoutEffect(() => {
    navigation.setOptions({ title: route.params.title });
  }, [navigation, route.params.title]);
  const [items, loading] = useReviewByUserAsUser(route.params.id);
  return (
    <View
      style={[
        styles.container,
        items.length === 0 && !loading ? styles.notFound : {},
      ]}
    >
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <ReviewCard
              key={item.id}
              review={item}
              containerStyle={styles.card}
              onPress={() => console.log("onReview...")}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? (
        <NotFound text={route.params.notFound} />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  card: {
    marginVertical: 8,
    marginHorizontal: 8,
  },
});
